import React from 'react';
import { useFormContext, Controller } from 'react-hook-form-new';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { getDateZeroTimeZoneISO, getTomorrowDate } from '../../../../utils/date';

import { DatePricker } from 'components';

interface DateRangeProps {
    dateStart: string;
    dateEnd: string;
}

export const DateRange = (props: DateRangeProps) => {
    const { dateStart = getDateZeroTimeZoneISO(), dateEnd = getDateZeroTimeZoneISO(getTomorrowDate()) } = props;
    const {
        control,
        formState: { errors },
        getValues,
        setValue,
    } = useFormContext();
    const [t] = useTranslation('admin-validation');

    return (
        <>
            <Controller
                control={control}
                name="dateStartSession"
                defaultValue={dateStart}
                rules={{
                    required: {
                        value: true,
                        message: t('required-select'),
                    },
                    validate: (value) => getDateStartValidationMessage(value, t, dateStart) || true,
                }}
                render={() => (
                    <DatePricker
                        name="dateStartSession"
                        useZeroTime
                        label="Начало действия сессии"
                        returnValue="start"
                        value={getValues('dateStartSession')}
                        errorMessage={t(errors.dateStartSession?.message as string)}
                        onChange={(v) => setValue('dateStartSession', v)}
                    />
                )}
            />
            <Controller
                control={control}
                name="dateEndSession"
                defaultValue={dateEnd}
                rules={{
                    required: {
                        value: true,
                        message: t('required-select'),
                    },
                    validate: (value) => getDateEndValidationMessage(value, t, getValues('dateStartSession')) || true,
                }}
                render={() => (
                    <DatePricker
                        useZeroTime
                        name="dateEndSession"
                        label="Конец действия сессии"
                        returnValue="start"
                        errorMessage={t(errors.dateEndSession?.message as string)}
                        value={getValues('dateEndSession')}
                        onChange={(v) => setValue('dateEndSession', v)}
                    />
                )}
            />
        </>
    );
};

const getDateStartValidationMessage = (value: Date, t: TFunction, defaultDateStart?: string) =>
    moment(value).isSameOrAfter(defaultDateStart || moment().format('LL')) ? '' : t('date-start-session');

const getDateEndValidationMessage = (value: Date, t: TFunction, dateStart: Date) =>
    moment(value).isSameOrAfter(dateStart) ? '' : t('date-end-session');
